import script from "./StatisticsChart5.vue?vue&type=script&setup=true&name=chart&lang=js"
export * from "./StatisticsChart5.vue?vue&type=script&setup=true&name=chart&lang=js"

const __exports__ = script;

export default __exports__